import { Http } from '@/lib/http';

export class LoanTypeService extends Http {
  constructor() {
    super();
    this.endPoint = 'loan-pro/settings/loan-types';
  }

  fetchLoanTypeById(id) {
    return this.httpClient().get(`${this.endPoint}/${id}`);
  }

  fetchLoanTypes() {
    return this.httpClient().get(this.endPoint);
  }

  fetchLoanTypeFilterOptions() {
    return this.httpClient().get(`${this.endPoint}/filter-options`);
  }

  createLoanType(loanType) {
    return this.httpClient().post(this.endPoint, loanType);
  }

  updateLoanType(id, updates) {
    return this.httpClient().patch(`${this.endPoint}/${id}`, updates);
  }

  deleteLoanType(id) {
    return this.httpClient().delete(`${this.endPoint}/${id}`);
  }
}